// extracted by mini-css-extract-plugin
export var dataCell = "_ow-2";
export var dataRow = "_ow-0";
export var headerRow = "_ow-1";